/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "./sign-request-by-volume-additional-services.css";
import { Label } from "@progress/kendo-react-labels";
import { useTranslation } from "react-i18next";
import { Traslates } from "../../pures";
import { FormDatePicker, DataPickerHLPure, ButtonHLPure } from "../../pures";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { Grid } from "@material-ui/core";
import { Button } from "@progress/kendo-react-buttons";
import { CheckBoxTemplatePure } from "../../pures";
import { TooltipFormPure } from "../../pures";
import LabelPure from "../../pures/label/label.pure";

const SignRequestByVolumeAdditionalServicesView = (props) => {
  const { t } = useTranslation();
  const { step, onHandleBack } = props;
  const { next, back } = step;
  const [errorInDate, setErrorInDate] = useState(false);

  const onChangeDate = (e) => {
    let todayDate = new Date();
    let eventDate = new Date(e.target.value);

    eventDate.setHours(0, 0, 0, 0);
    todayDate.setHours(0, 0, 0, 0);

    if (eventDate < todayDate || eventDate > finalDate || eventDate === null) {
      setErrorInDate(true);
      props.handleLimitDate(today);
      setTimeout(() => {
        setErrorInDate(false);
      }, 3000);
    }
    else if (eventDate >= todayDate || eventDate <= finalDate) {
      setErrorInDate(false);
      props.handleLimitDate(e.target.value);
    }
  };

  let {
    setSignatureTypes,
    setProcessTypes,
    requestName,
    handleAdditionalServices,
  } = props;

  useEffect(() => {
    if (props.signatureTypes.length > 0) {
      setSignatureTypes(
        props.signatureTypes.map((item) => ({ ...item, isActive: false }))
      );
    }

    if (props.processTypes.length > 0) {
      setProcessTypes(
        props.processTypes.map((item) => ({ ...item, isActive: false }))
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.signatureTypes, props.processTypes]);

  // eslint-disable-next-line no-extend-native
  Date.prototype.addDays = function (days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  };

  const today = new Date();

  const finalDate =
    props.signatureByVolumeProfile.numberDaysLimit === 0
      ? false
      : today.addDays(props.signatureByVolumeProfile.numberDaysLimit);

  const validatorOnCheckedSignatures =
    props.signatureTypeESignChecked ||
    props.signatureTypeAdvancedChecked ||
    props.signatureTypeAutographChecked;

  const validatorOnCheckedProccess =
    props.processTypeRandomChecked ||
    props.processTypeSequentialChecked ||
    props.processTypeAprovationChecked ||
    props.processTypeAprovationSequentialChecked;

  return (
    <div className="card-description-reliable">
      <Form
        onSubmitClick={(e) => handleAdditionalServices(props.limitDate === "" ? finalDate : props.limitDate)}
        render={(formRenderProps) => {
          return (
            <FormElement>
              <Grid container lg={12} md={12} style={{ width: "100%" }}>
                <Grid item xs={6} style={{ width: "100%" }}>
                  <Grid item xs={12}>
                    <LabelPure title={`${t("signRequestByVolume.requestName")} ${requestName}`} />
                  </Grid>
                  {/* Checkboxes aditional services */}
                  <Grid
                    item
                    lg={12}
                    md={12}
                    xs={6}
                    className="SignatureRequestByVolumeAdditionalServices-container"
                  >
                    <>
                      <TooltipFormPure
                        title={t("signatureRequestView2.services")}
                        tooltipTitle={t(
                          "signatureRequestView2.aditionalServices"
                        )}
                        tooltipDescription={t(
                          "signatureRequestView2.servicesDetail"
                        )}
                        text={t("signatureRequestView2.aditionalServices")}
                      />

                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {props.serviceSTWillShow === true ? (
                          <CheckBoxTemplatePure
                            label={t("signRequestByVolume.serviceTimeStamp")}
                            id={"timeStamp"}
                            name={"timeStamp"}
                            value={props.serviceSTChecked}
                            checked={props.serviceSTChecked}
                            onChange={props.onSelectServiceST}
                            placeHolder
                          />
                        ) : null}

                        {props.serviceCMWillShow === true ? (
                          <CheckBoxTemplatePure
                            label={t("signRequestByVolume.serviceConservation")}
                            id={"conservationMessage"}
                            name={"conservationMessage"}
                            value={props.serviceCMChecked}
                            checked={props.serviceCMChecked}
                            onChange={props.onSelectServiceCM}
                            placeHolder
                          />
                        ) : null}
                      </div>
                    </>
                  </Grid>
                  {/*Signatures type */}
                  <Grid
                    item
                    lg={6}
                    md={6}
                    es={12}
                    className="SignatureRequestByVolumeAdditionalServices-container"
                  >
                    <div>
                      <TooltipFormPure
                        title={t("signatureRequestView2.tooltipSignatureTypes")}
                        tooltipTitle={t(
                          "signatureRequestView2.tooltipSignatureTypes"
                        )}
                        tooltipDescription={t(
                          "signatureRequestView2.tooltipSignatureTypesOne",
                          "signatureRequestView2.tooltipSignatureTypes",
                          "signatureRequestView2.tooltipSignatureTypeThree"
                        )}
                        text={t("signatureRequestView2.tooltipSignatureTypes")}
                      />
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {props.signatureTypeESignWillShow === true ? (
                          <CheckBoxTemplatePure
                            label={t("signRequestByVolume.eSign")}
                            id={"signatureTypeESign"}
                            name={"eSign"}
                            value={props.signatureTypeESignChecked}
                            checked={props.signatureTypeESignChecked}
                            onChange={props.onSelectESign}
                            placeHolder
                          />
                        ) : null}
                        {props.signatureTypeAdvancedWillShow === true ? (
                          <CheckBoxTemplatePure
                            label={t("signRequestByVolume.advanced")}
                            id={"signatureTypeAdvanced"}
                            name={"advanced"}
                            value={props.signatureTypeAdvancedChecked}
                            checked={props.signatureTypeAdvancedChecked}
                            onChange={props.onSelectAdvanced}
                            placeHolder
                          />
                        ) : null}
                        {props.signatureTypeAutographWillShow === true ? (
                          <CheckBoxTemplatePure
                            label={t("signRequestByVolume.autograph")}
                            id={"signatureTypeAutograph"}
                            name={"autograph"}
                            value={props.signatureTypeAutographChecked}
                            checked={props.signatureTypeAutographChecked}
                            onChange={props.onSelectAutograph}
                            placeHolder
                          />
                        ) : null}
                      </div>
                      {props.errorSignatureTypeId && (
                        <span className="hint-message-error-name">
                          {t("signatureRequestView2.slectedTypeOfSignature")}
                        </span>
                      )}
                    </div>
                  </Grid>
                  {/* Checkboxes signatureFlow */}
                  <Grid
                    item
                    lg={6}
                    md={6}
                    es={12}
                    className="SignatureRequestByVolumeAdditionalServices-container"
                  >
                    {props.processTypesInputValue && (
                      <>
                        <TooltipFormPure
                          title={t("signatureRequestView2.flowSignatures")}
                          tooltipTitle={t(
                            "signatureRequestView2.signatureFlow"
                          )}
                          tooltipDescription={t(
                            "signatureRequestView2.flowSignaturesDetail"
                          )}
                          text={t("signatureRequestView2.signatureFlow")}
                        />
                        <div style={{ display: "flex", flexWrap: "wrap" }}>
                          {props.processTypeRandomWillShow === true ? (
                            <CheckBoxTemplatePure
                              label={t("signRequestByVolume.random")}
                              id={"processTypeRandom"}
                              name={"random"}
                              value={props.processTypeRandomChecked}
                              checked={props.processTypeRandomChecked}
                              onChange={props.onSelectRandom}
                              placeHolder
                            />
                          ) : null}

                          {props.processTypeSequentialWillShow === true ? (
                            <CheckBoxTemplatePure
                              label={t("signRequestByVolume.sequential")}
                              id={"processTypeSequential"}
                              name={"sequential"}
                              value={props.processTypeSequentialChecked}
                              checked={props.processTypeSequentialChecked}
                              onChange={props.onSelectSequential}
                              placeHolder
                            />
                          ) : null}

                          {props.processTypeAprovationlWillShow === true ? (
                            <CheckBoxTemplatePure
                              label={t("signRequestByVolume.approbation")}
                              id={"processTypeAprovation"}
                              name={"aprovation"}
                              value={props.processTypeAprovationChecked}
                              checked={props.processTypeAprovationChecked}
                              onChange={props.onSelectAprovation}
                              placeHolder
                            />
                          ) : null}

                          {props.processTypeAprovationSequentialWillShow ===
                            true ? (
                            <CheckBoxTemplatePure
                              label={t(
                                "signRequestByVolume.sequentialApprobation"
                              )}
                              id={"processTypeAprovationSequencial"}
                              name={"aprovationSequencial"}
                              value={
                                props.processTypeAprovationSequentialChecked
                              }
                              checked={
                                props.processTypeAprovationSequentialChecked
                              }
                              onChange={props.onSelectAprovationSequential}
                              placeHolder
                            />
                          ) : null}
                        </div>
                      </>
                    )}
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={6}
                  className="SignatureRequestByVolumeAdditionalServices-half-grid"
                >
                  <Grid item>
                    <Traslates>
                      <Field
                        id={"date"}
                        name={"date"}
                        labelDataPicker={t("signRequestByVolume.dateRequest")}
                        valueDate={
                          props.limitDate === "" ? finalDate : props.limitDate
                        }
                        limitDate={today}
                        maxDate={finalDate}
                        handleChangeDate={(e) => onChangeDate(e)}
                        component={DataPickerHLPure}
                        validator={props.validator.limitDateValidator}
                        required={true}
                      />
                      {errorInDate ? (
                        <span className="hint-message-error">
                          {t("signature.request.limitDateValidator")}
                        </span>
                      ) : null}
                    </Traslates>
                  </Grid>
                </Grid>

                <div className="SignatureRequestByVolumeAdditionalServices-action-buttons">
                  <ButtonHLPure
                    nameBtn={back}
                    primary={false}
                    onClickBtn={(event) => onHandleBack(event)}
                  />
                  <ButtonHLPure
                    nameBtn={next}
                    primary={true}
                    onClickBtn={formRenderProps.onSubmit}
                    disabled={
                      !formRenderProps.allowSubmit ||
                      !validatorOnCheckedSignatures ||
                      !validatorOnCheckedProccess
                    }
                  />
                </div>
              </Grid>
            </FormElement>
          );
        }}
      />
    </div>
  );
};

export default SignRequestByVolumeAdditionalServicesView;
